import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SideBar } from '../../organisms/mypage/SideBar';
import { Heading, LabelText } from '@sheinc/shelikes-design-system';
import './page.module.scss';
import { BackButtonHeader } from '../../organisms/mypage/BackButtonHeader';
import { V3Routes } from '../../../routes';
import { ChevronLeft } from '@material-ui/icons';

type SettingPaneProps = {
  id?: string;
  activeMenu: string;
  title?: string;
  children: ReactNode;
  hasBackButton?: boolean;
};

// /home/mypage/** の中で表示されるモーダルに使用しているコンポーネント
// マイページリニューアルによりここで表示される項目群はSETTINGSという名称になる
export const SettingPane = observer(
  ({ id = undefined, activeMenu, title, children, hasBackButton = false }: SettingPaneProps) => {
    return (
      <div styleName="pane" id={id}>
        {GlobalStatesV3.viewport.isDesktop && <SideBar activeMenu={activeMenu} />}
        <div styleName="pane-main">
          {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.myPage()} />}
          <PaneHeader title={title} hasBackButton={hasBackButton} />
          {children}
        </div>
      </div>
    );
  }
);

type HeaderProps = { title: string | undefined; hasBackButton?: boolean };
const PaneHeader = ({ title, hasBackButton = false }: HeaderProps) => (
  <div styleName="pane-header">
    {GlobalStatesV3.viewport.isDesktop && hasBackButton && <BackButton />}
    {title && <Heading size="S">{title}</Heading>}
  </div>
);

export const PaneSubHeader = ({ title }: HeaderProps) => (
  <div styleName="pane-sub-header">
    <Heading size="XS">{title}</Heading>
  </div>
);

type Props = {
  onClick?: () => void;
};

const BackButton = ({ onClick = GlobalStatesV3.routing.goBack }: Props) => (
  <div styleName="back-button" onClick={onClick}>
    <ChevronLeft styleName="icon" />
    <LabelText size="M">戻る</LabelText>
  </div>
);
